/**
 * Átomos visuales reutilizables del formulario de reparaciones:
 *  - `Field`: input estándar con label en font-mono.
 *  - `RO`: par label/valor de sólo lectura (fila key/value con separador punteado).
 *  - `Dialog`: modal centrado simple con cierre por overlay.
 *
 * DS v2 — inputs con radius suave y focus-ring verde, RO en filas divididas.
 */
import { X } from "lucide-react";

export function Field({ label, value, onChange, disabled, mono, type = "text", placeholder, testid }) {
  return (
    <div>
      <label className="font-mono text-[10px] uppercase tracking-widest text-[#8A9098] font-semibold">
        {label}
      </label>
      <input
        type={type}
        disabled={disabled}
        value={value ?? ""}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e.target.value)}
        data-testid={testid}
        className={`mt-1 ds-input disabled:bg-[#F5F6F2] disabled:text-[#8A9098] ${mono ? "mono" : ""}`}
      />
    </div>
  );
}

export function RO({ label, value, mono, strong }) {
  return (
    <div className="flex items-baseline gap-3 py-2 border-b border-dashed border-[#E6E7E1] last:border-0">
      <div className="font-mono text-[10px] uppercase tracking-widest text-[#8A9098] font-semibold shrink-0 min-w-[105px]">
        {label}
      </div>
      <div className={`text-sm text-[#0F1210] ${mono ? "font-mono text-[12.5px]" : ""} ${strong ? "font-semibold" : ""}`}>
        {value || <span className="text-[#8A9098] font-normal">—</span>}
      </div>
    </div>
  );
}

export function Dialog({ children, onClose, title }) {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="ds-card w-full max-w-sm" style={{ boxShadow: "var(--shadow-lg)" }} onClick={(e) => e.stopPropagation()}>
        <div className="ds-card-h">
          <div className="t">{title}</div>
          <button onClick={onClose} className="p-1 rounded-md hover:bg-[#F5F6F2] text-[#4B5158]"><X size={14} /></button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
